module.exports = __webpack_public_path__ + "static/media/marketplace.84f2b10a.svg";